import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import EnquiryPopup from './index';
import useEnquiryTriggers from './useEnquiryTriggers';

/**
 * Mounts a single, app-wide EnquiryPopup driven by a global exit-intent trigger.
 * Should sit inside <BrowserRouter> + the public layout (so admin pages are excluded).
 *
 * Behaviour:
 *   - After user is on the page >= 30 seconds AND triggers exit-intent → show popup
 *   - One-shot per session (auto); property pages use per-project callback rules instead
 *   - Disabled on admin & property/blog pages (they have their own contextual popups)
 */
export default function GlobalEnquiryProvider() {
    const location = useLocation();
    const [open, setOpen] = useState(false);
    const [triggerType, setTriggerType] = useState('exit_intent');

    const pathname = location.pathname || '/';
    // Skip global trigger on admin + pages that own their own enquiry experience
    const isAdmin = pathname.startsWith('/admin');
    const isProject = pathname.startsWith('/property/');
    const isBlogDetail = /^\/blog\/[^/]+$/.test(pathname);
    const enabled = !isAdmin && !isProject && !isBlogDetail;

    useEnquiryTriggers({
        mode: 'global',
        exitIntent: enabled,
        minTimeOnPageMs: 30000,
        onShow: (type) => {
            setTriggerType(type);
            setOpen(true);
        },
    });

    if (isAdmin) return null;

    return (
        <EnquiryPopup
            open={open}
            onClose={() => setOpen(false)}
            contextTitle="Before you go…"
            contextSubtitle="Our advisors are online now"
            source="exit_intent"
            triggerType={triggerType}
        />
    );
}
